'use client';
import classNames from 'classnames';
import { useState } from 'react';

type Checkbox = {
  toggleCheckbox: () => void;
  isChecked: boolean;
  label?: string | React.ReactNode;
  isBold: boolean;
};

const Checkbox: React.FC<Checkbox> = ({
  toggleCheckbox,
  label,
  isChecked,
  isBold,
}: Checkbox) => {
  return (
    <div
      className="flex gap-2 items-center"
      role="button"
      tabIndex={0}
      onClick={toggleCheckbox}
    >
      <div
        className={`flex self-start items-center justify-center shrink-0 size-5 rounded-full cursor-pointer ${
          isChecked ? 'bg-primary-800' : 'bg-transparent border border-gray-400'
        } select-none`}
      >
        {isChecked && <div className="bg-white size-2.5 rounded-full" />}
      </div>
      {!!label && (
        <p
          className={classNames('font-medium text-gray-900 text-sm', {
            'font-semibold': isBold,
          })}
        >
          {label}
        </p>
      )}
    </div>
  );
};

type CheckBoxGroup = {
  options: { value: string; label: string; isBold?: boolean }[];
  defaultCheckedOption?: string;
  onClick: (val: string) => void;
  label?: string;
};

export const CICheckboxGroup: React.FC<CheckBoxGroup> = ({
  options,
  defaultCheckedOption,
  onClick,
  label,
}) => {
  const [checkedOption, setCheckedOption] = useState(defaultCheckedOption);

  const handleCheckboxClick = (value: string) => {
    setCheckedOption(value);
    onClick(value);
  };

  return (
    <div className="flex flex-col gap-2">
      {!!label && (
        <p className="font-medium text-base text-gray-800">{label}</p>
      )}
      <div className="flex flex-col gap-2">
        {options.map((item) => (
          <Checkbox
            key={item.label}
            isChecked={checkedOption === item.value}
            toggleCheckbox={() => {
              handleCheckboxClick(item.value);
            }}
            label={item.label}
            isBold={!!item?.isBold}
          />
        ))}
      </div>
    </div>
  );
};

export default CICheckboxGroup;
